import HTTP from '@/utils/http-common';

const getOneDistSupplier = (distributorId) => HTTP.get(`/distsuppliers/${distributorId}`);
const updateSupplierContact = (contact) => HTTP.put('/distsuppliers/contacts', contact);
const createSupplierContact = (contact) => HTTP.post('/distsuppliers/contacts', contact);
const deleteSupplierContact = (contactId) => HTTP.delete(`/distsuppliers/contacts/${contactId}`);
const updateSupplierNote = (note) => HTTP.put('/distsuppliers/notes', note);
const createSupplierNote = (note) => HTTP.post('/distsuppliers/notes', note);
const deleteSupplierNote = (noteId) => HTTP.delete(`/distsuppliers/notes/${noteId}`);
const updateDistSupplier = async (supplierId, data) => (await HTTP.post(`/suppliers/${supplierId}/distSupplier`, data)).data;
export {
  getOneDistSupplier,
  createSupplierContact,
  updateSupplierContact,
  deleteSupplierContact,
  createSupplierNote,
  updateSupplierNote,
  deleteSupplierNote,
  updateDistSupplier
};
